




























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl
} from "@root/lib/decorator";
const bonus = namespace("bonus");
const root = namespace("root");
@Component({})
@SearchbarControl()
@pagination("getData", { pageSize: 50 })
@loading(true)
export default class tyreClaimPage extends Vue {
  formOptionList: any = [
    {
      label: "创建时间",
      key: "date",
      type: "datePicker",
      value: "",
      pickerType: "datetimerange",
      rangeSeparator: "-",
      prefixIcon: "",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      defaultTime: ["00:00:00", "23:59:59"]
    },
    {
      key: "couponCode",
      value: "",
      label: "券编码",
      type: "input"
    },
    {
      key: "couponStatus",
      value: "",
      label: "券状态",
      type: "ddPicker",
      ddCode: "WT_COUPON_STATUS"
    },
    {
      key: "ownerPhone",
      value: "",
      label: "车主手机",
      type: "input"
    },
    {
      key: "storeCode",
      value: "",
      label: "门店编码",
      type: "input"
    }
  ];
  onFormDataChange(val: any) {
    const { date, ...other } = val;
    this.form = {
      ...other,
      startTime: (date && date[0]) || null,
      endTime: (date && date[1]) || null
    };
  }
  form: any = {};
  loading: boolean = false;
  total: number = 0;
  @bonus.Action queryCouponPage;

  @root.State ddCodes;

  dataList = [];

  mounted() {
    this.getData();
    this.$dd.register(["WT_COUPON_STATUS", "WT_COUPON_TYPE"]).query();
  }
  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };
    const { list, total } = await this.queryCouponPage({
      input: this.form,
      pageInput
    });
    this.dataList = list;
    (this as any).total = total;
  }
  goRouter(row) {
    this.$router.push({
      name: "couponDetailPCR",
      query: { code: row && row.couponCode } // 创建，查看，编辑，复制 0,1,2,3 <string>
    });
  }
}
